import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { loadUomClassDropdownData, loadUomMeasureOfDropdownData, postUnitOfMeasureDatas } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { ADDED_BY_ID } from "../../../Constants";
import * as HeaderAuthentication from '../../HeaderAuthentication'

const statustions = [
    { value: 87, label: "Active" },
    { value: 88, label: "Inactive" }
]

const AddUom = (props) => {

    const { unitOfMeasureClassDropdownData, unitOfMeasureMeasureOfDropdownData, } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;
    const singleUnitOfMeasure = props.singleUnitOfMeasure;
    const uomID = props.uomID;

    let dispatch = useDispatch();

    const [uomData, setUomData] = useState({
        UOMCode: "",
        UOMDescription: "",
        MeasureOfID: null,
        UOMClassID: null,
        StatusID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
    });

    const [errors, setErrors] = useState({
        UOMCode: "",
        UOMDescription: "",
        MeasureOfID: null,
        UOMClassID: null,
    });

    useEffect(() => {
        dispatch(loadUomClassDropdownData());
        dispatch(loadUomMeasureOfDropdownData());
    }, []);

    useEffect(() => {
        if (uomID && singleUnitOfMeasure?.length > 0) {
            const uomDatas = singleUnitOfMeasure[0];
            setUomData({
                UOMID: uomID,
                UOMCode: uomDatas.UOMCode || "",
                UOMDescription: uomDatas.Description || "",
                MeasureOfID: uomDatas.MeasureOfID || "",
                UOMClassID: uomDatas.ClassID || "",
                CompanyID: uomDatas.CompanyID,
                AddedByID: ADDED_BY_ID,
                StatusID: uomDatas.StatusID || null
            });
        }
    }, [uomID, singleUnitOfMeasure]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUomData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "" // Clear error on typing
        }));
    };

    const handleSelectChange = (selectedOption, field) => {
        setUomData((prevData) => ({
            ...prevData,
            [field]: selectedOption ? selectedOption.value : null
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [field]: "" // Clear error on selecting
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!uomData.UOMCode) newErrors.UOMCode = "required!";
        if (!uomData.UOMDescription) newErrors.UOMDescription = "required!";
        if (!uomData.MeasureOfID) newErrors.MeasureOfID = "required!";
        if (!uomData.UOMClassID) newErrors.UOMClassID = "required!";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddUomData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(uomData),
            };
            dispatch(postUnitOfMeasureDatas(requestOption, props.handleCloseModal, uomID, props.uomData));
            console.log(uomData, 'uomData');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{uomID ? "Edit Unit of Measure (UOM)" : "Add Unit of Measure (UOM)"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>UOM Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="UOMCode"
                                            value={uomData.UOMCode}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.UOMCode && <div className="text-danger">{errors.UOMCode}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>UOM Description <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="UOMDescription"
                                            value={uomData.UOMDescription}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.UOMDescription && <div className="text-danger">{errors.UOMDescription}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Measure Of <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={unitOfMeasureMeasureOfDropdownData}
                                            placeholder="Select"
                                            value={unitOfMeasureMeasureOfDropdownData.find(option => option.value === uomData.MeasureOfID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "MeasureOfID")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.MeasureOfID && <div className="text-danger">{errors.MeasureOfID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Class <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={unitOfMeasureClassDropdownData}
                                            placeholder="Select"
                                            value={unitOfMeasureClassDropdownData.find(option => option.value === uomData.UOMClassID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "UOMClassID")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.UOMClassID && <div className="text-danger">{errors.UOMClassID}</div>}
                                </Col>
                                {uomID && <Col md={4}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statustions}
                                            value={statustions.find(option => option.value === uomData.StatusID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "StatusID")}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddUomData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddUom;
